import React from "react";
import { useMutation } from "@apollo/client";
import { TOGGLE_AI_IGNORE_RETRAINING } from "graphql/mutations/page";
import { Checkbox } from "@periplus/ui-library";

// Define the props type
type AIIgnoreRetrainingCheckboxProps = {
  id: string;
  initialChecked: boolean;
};

export function AIIgnoreRetrainingCheckbox({
  id,
  initialChecked,
}: AIIgnoreRetrainingCheckboxProps) {
  const [checked, setChecked] = React.useState(initialChecked);

  const [updateAIIgnoreRetraining] = useMutation(TOGGLE_AI_IGNORE_RETRAINING);

  const handleCheckboxChange = async () => {
    const newValue = !checked;
    setChecked(newValue);

    try {
      await updateAIIgnoreRetraining({
        variables: {
          id: id,
          value: newValue,
        },
      });
    } catch (error) {
      console.error("Failed to update ai_ignore_retraining:", error);
      // If the update fails, revert the checkbox state
      setChecked(!newValue);
    }
  };

  return <Checkbox checked={checked} onChange={handleCheckboxChange} />;
}
